import React from 'react';
import _ from 'lodash';

import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import {
  ArrowDropUp,
  ArrowDropDown
} from '@mui/icons-material';



const ButtonsContainerDiv = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch'
});

const ArrowButton = styled(Button)({
  minWidth: 'unset',
  padding: 0
});



export interface IArgs {
  idOrdering: string[];
  onChangeIdOrdering: (value: string[]) => void;
  isDisabled?: boolean;
}

export interface IReturn {
  elControls: JSX.Element[];
}

export function useOrderableControls({
  idOrdering, onChangeIdOrdering, isDisabled
}: IArgs): IReturn {
  const handleClickUp = React.useCallback(
    (event: React.MouseEvent, fromIndex: number) => {
      event.stopPropagation();
      onChangeIdOrdering([
        ...idOrdering.slice(0, fromIndex - 1),
        idOrdering[fromIndex],
        idOrdering[fromIndex - 1],
        ...idOrdering.slice(fromIndex + 1)
      ]);
    },
    [
      idOrdering,
      onChangeIdOrdering
    ]
  );



  const handleClickDown = React.useCallback(
    (event: React.MouseEvent, fromIndex: number) => {
      event.stopPropagation();
      onChangeIdOrdering([
        ...idOrdering.slice(0, fromIndex),
        idOrdering[fromIndex + 1],
        idOrdering[fromIndex],
        ...idOrdering.slice(fromIndex + 2)
      ]);
    },
    [
      idOrdering,
      onChangeIdOrdering
    ]
  );



  return {
    elControls: _.map(idOrdering, (id, index, array) => {
      const isFirst = index === 0;
      const isLast = index === array.length - 1;

      return (
        <ButtonsContainerDiv>
          <ArrowButton
            variant="text"
            onClick={event => handleClickUp(event, index)}
            disabled={isDisabled || isFirst}>
            <ArrowDropUp />
          </ArrowButton>

          <ArrowButton
            variant="text"
            onClick={event => handleClickDown(event, index)}
            disabled={isDisabled || isLast}>
            <ArrowDropDown />
          </ArrowButton>
        </ButtonsContainerDiv>
      );
    })
  };
}
